import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-orange-500 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                            <h3 className="font-bold text-4xl mb-4">Rally</h3>
                            <div className='text-md font-medium text-gray-600'>
                                <h5>University Marketplace App</h5>
                                <p>Connect. Trade. Thrive.</p>
                                <p>Your Campus Marketplace</p>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                        <h6 className="text-orange-500 text-xl font-bold mb-4">EXPLORE</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <HashLink to="#about" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">About</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#features" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Features</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#contact" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                        </li>                            
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-orange-500 text-xl font-bold mb-4">KEY FEATURES</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <Link to="#" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Secure Authentication</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Real-time Messaging</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">University-specific Listings</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-orange-500 hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Secure Payments</Link>
                        </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-orange-500">
                        <div className="text-xl mb-6">
                            Connect With Us
                        </div>

                                <div className="text-md font-medium mb-6">
                                    Follow Rally on social media
                                </div>
                        <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <Link to="#" className="flex justify-center items-center text-orange-500 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Twitter">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                                        </svg>
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-orange-500 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-orange-500 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Instagram">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="16" cy="16" r="4"></circle><path d="M16 0C11.6 0 11.1 0 9.4 0.1C7.8 0.1 6.6 0.4 5.5 0.8C4.5 1.1 3.6 1.6 2.7 2.5C1.8 3.4 1.3 4.3 1 5.3C0.6 6.4 0.3 7.6 0.3 9.2C0.2 10.9 0.2 11.4 0.2 15.8C0.2 20.2 0.2 20.7 0.3 22.4C0.3 24 0.6 25.2 1 26.3C1.3 27.3 1.8 28.2 2.7 29.1C3.6 30 4.5 30.5 5.5 30.8C6.6 31.2 7.8 31.5 9.4 31.5C11.1 31.6 11.6 31.6 16 31.6C20.4 31.6 20.9 31.6 22.6 31.5C24.2 31.5 25.4 31.2 26.5 30.8C27.5 30.5 28.4 30 29.3 29.1C30.2 28.2 30.7 27.3 31 26.3C31.4 25.2 31.7 24 31.7 22.4C31.8 20.7 31.8 20.2 31.8 15.8C31.8 11.4 31.8 10.9 31.7 9.2C31.7 7.6 31.4 6.4 31 5.3C30.7 4.3 30.2 3.4 29.3 2.5C28.4 1.6 27.5 1.1 26.5 0.8C25.4 0.4 24.2 0.1 22.6 0.1C20.9 0 20.4 0 16 0ZM16 2.9C20.3 2.9 20.8 2.9 22.4 3C23.8 3 24.8 3.3 25.4 3.6C26.3 3.9 26.9 4.3 27.6 5C28.3 5.7 28.7 6.3 29 7.2C29.3 7.8 29.6 8.8 29.6 10.2C29.7 11.8 29.7 12.3 29.7 16.6C29.7 20.9 29.7 21.4 29.6 23C29.6 24.4 29.3 25.4 29 26C28.7 26.9 28.3 27.5 27.6 28.2C26.9 28.9 26.3 29.3 25.4 29.6C24.8 29.9 23.8 30.2 22.4 30.2C20.8 30.3 20.3 30.3 16 30.3C11.7 30.3 11.2 30.3 9.6 30.2C8.2 30.2 7.2 29.9 6.6 29.6C5.7 29.3 5.1 28.9 4.4 28.2C3.7 27.5 3.3 26.9 3 26C2.7 25.4 2.4 24.4 2.4 23C2.3 21.4 2.3 20.9 2.3 16.6C2.3 12.3 2.3 11.8 2.4 10.2C2.4 8.8 2.7 7.8 3 7.2C3.3 6.3 3.7 5.7 4.4 5C5.1 4.3 5.7 3.9 6.6 3.6C7.2 3.3 8.2 3 9.6 3C11.2 2.9 11.7 2.9 16 2.9Z"></path>
                                        </svg>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                    </div>          

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                        <div className="text-center text-sm text-gray-500 py-4">
                            © {new Date().getFullYear()} Rally. All rights reserved.
                        </div>
                    </div>

                </div>
                
            </footer>
        </>
    )
}
export default Footer;
